module.exports = __webpack_public_path__ + "img/Slide8.a45b6119.png";